@if (icon()) {
<span class="fa-regular {{ icon() }}"></span>
}
{{ buttonLabel() }}
@if (iconRight()) {
<span class="fa-regular {{ iconRight() }}"></span>
}
